/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

// This is not for the public API
// TODO:#my-account-architecture - Number.MAX_VALUE?
export const MAX_OCC_INTEGER_VALUE = 2147483647;
